export default function getPercentageYield(earnedBLID, USDDeposit, BLIDPrice) {
    return USDDeposit && BLIDPrice ? ((earnedBLID * BLIDPrice) / USDDeposit) * 100 : 0;
}
